import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white">
      <div className="bg-black text-white py-10 px-6">
        <div className="container mx-auto max-w-4xl">
          <Link to="/" className="text-gray-300 hover:text-white text-sm inline-flex items-center gap-2 mb-4">
            <ArrowLeft className="w-4 h-4" /> Volver
          </Link>
          <h1 className="text-4xl md:text-5xl font-bold" style={{ fontFamily: 'Playfair Display' }}>
            Política de Privacidad
          </h1>
          <p className="text-gray-400 mt-2 text-sm">Última actualización: 27 de abril de 2026</p>
        </div>
      </div>

      <article className="container mx-auto max-w-3xl px-6 py-12 text-gray-800 leading-relaxed space-y-8" data-testid="privacy-article">
        <section>
          <h2 className="text-2xl font-bold">1. Responsable del tratamiento</h2>
          <ul className="list-none pl-0 mt-2 space-y-1">
            <li><strong>Denominación social:</strong> ARTHUR FITZ S.L.</li>
            <li><strong>CIF:</strong> B86252848</li>
            <li><strong>Domicilio:</strong> Gran Vía 46, 9A — 28013 Madrid</li>
            <li><strong>Email:</strong> info@arthurfitz.com</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold">2. Datos que tratamos</h2>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>Datos identificativos y de contacto: nombre, apellidos, email, teléfono, dirección postal.</li>
            <li>Datos de pago: procesados directamente por nuestras pasarelas (Stripe, Bizum). No almacenamos números de tarjeta.</li>
            <li>Datos de navegación: IP, tipo de dispositivo, cookies analíticas (previo consentimiento).</li>
            <li>Datos de pedido: productos, fechas, historial de compras.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold">3. Finalidades y base legal</h2>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li><strong>Gestión del pedido y contrato de venta</strong> (ejecución contractual).</li>
            <li><strong>Atención al cliente y postventa</strong> (ejecución contractual).</li>
            <li><strong>Newsletter y marketing</strong> (consentimiento expreso, revocable en cualquier momento).</li>
            <li><strong>Obligaciones fiscales y contables</strong> (obligación legal).</li>
            <li><strong>Prevención del fraude y seguridad</strong> (interés legítimo).</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold">4. Destinatarios</h2>
          <p className="mt-2">
            Comunicamos datos estrictamente necesarios a: proveedores de pago (Stripe, Bizum),
            empresas de mensajería para la entrega, proveedor de email (Resend, Cloudinary
            para imágenes) y, cuando sea obligatorio, a autoridades fiscales. No cedemos
            datos a terceros con fines comerciales.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold">5. Transferencias internacionales</h2>
          <p className="mt-2">
            Algunos proveedores (Stripe, Cloudinary, Resend) pueden tratar datos en EE.UU.
            Todos disponen de garantías adecuadas conforme al RGPD (Cláusulas Contractuales
            Tipo o certificación EU-US Data Privacy Framework).
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold">6. Plazo de conservación</h2>
          <ul className="list-disc pl-6 mt-2 space-y-1">
            <li>Datos de cliente y pedidos: durante la relación + <strong>5 años</strong> (prescripción mercantil).</li>
            <li>Datos contables y fiscales: <strong>6 años</strong> (art. 30 Código de Comercio).</li>
            <li>Datos para newsletter: hasta la baja del usuario.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold">7. Tus derechos</h2>
          <p className="mt-2">
            Puedes ejercer en cualquier momento tus derechos de <strong>acceso,
            rectificación, supresión, oposición, limitación, portabilidad y revocación</strong>
            {' '}del consentimiento enviando un email a{' '}
            <a href="mailto:info@arthurfitz.com" className="text-black underline">
              info@arthurfitz.com
            </a>
            {' '}con el asunto "RGPD - [derecho]".
          </p>
          <p className="mt-2">
            Asimismo, puedes presentar una reclamación ante la{' '}
            <strong>Agencia Española de Protección de Datos</strong> (
            <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="text-black underline">
              aepd.es
            </a>
            ).
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold">8. Cookies</h2>
          <p className="mt-2">
            Consulta nuestra{' '}
            <Link to="/cookies" className="text-black underline">Política de Cookies</Link>
            {' '}para información detallada.
          </p>
        </section>
      </article>
    </div>
  );
}
